import styled from "styled-components/macro"

export const StartSessionContainer = styled.div`
  > div {
    margin-bottom: 2rem;
  }
`
